export default {
    api_url: 'https://vd3pmwnf80.execute-api.us-east-1.amazonaws.com/prod',
    public_url:'r33.ch'
}
